import { defineComponent, onMounted, onUnmounted } from 'vue';
import { MultiSelect } from '@studyportals/multiselect';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import AccountManagerCode from '@/presentation/components/campaign-management/account-manager/account-manager.code';

export default defineComponent({
	components: {
		LoadingWrapper,
		MultiSelect
	},
	setup: () => {
		const code = new AccountManagerCode();

		onMounted(code.mounted.bind(code));
		onUnmounted(code.unmounted.bind(code));

		return {
			loadingType: code.loadingType,
			accountManagerDropdown: code.accountManagerDropdown,
			options: code.options,
			isLoading: code.isLoading,
			isFieldValidatedAndMissing: code.isFieldValidatedAndMissing,
			setAccountManager: code.setAccountManager.bind(code)
		};
	}
});
